window._TOOLS = {
  DATE_NOW: new Date(),
  templateStr: function (str, data) {
    for (var k in data) {
      str = str.split('%' + k + '%').join(data[k])
    }
    return str;
  },
  dayDiff: function (d1, d2,isString) {
      isString = !!isString;

      d1 = _TOOLS.strToDate(d1);
      d2 = _TOOLS.strToDate(d2);

    var day = 60 * 60 * 24 * 1000;
    return Math.floor(((d2.getTime() - d1.getTime()) / day));
  },
  _scrollTo: function (id) {
    var e = document.getElementById(id),
        box = e.getBoundingClientRect();
    window.scrollBy(0, box.top);
  },
  scrollTo: function (id, delay) {
    delay = delay || 500
    var e = document.getElementById(id),
      box = e.getBoundingClientRect(),
        k, inc;
    inc = (box.top >= 0) ? 1 : -1;
    for (k = 0; k < 49; k++){
      setTimeout(function () {
        _TOOLS._scrollTo(id)
        window.scrollBy(0, Math.floor(box.top / delay / 10))
      }, 10 * k);
    }
    setTimeout(function () {
      _TOOLS._scrollTo(id)
    }, 500);
  },
  isIntervalDate: function(date, intervals) {
    if(!date || intervals === "|" ) { return true; }

    if(intervals[0] === ',') { intervals = intervals.substring(1);  }
    if(intervals[0] === '|' && intervals[1] === ',') { intervals = intervals.substring(2);  }

    var dateCheck = new Date(_TOOLS.strToDate(date));
    var date2 = new Date();
    var date1 = new Date();
    var resultsInterval = [];

    intervals = intervals.split(",");

    intervals.map(interval => {
      if(!interval){ return; }
      var dates_interval = interval.split("|");
      date1.setFullYear(date1.getFullYear() - 1000);
      if (!!dates_interval[0]) {
        date1 = new Date(_TOOLS.strToDate(dates_interval[0]));
      }
      date2.setFullYear(date2.getFullYear() + 1000);
      if (!!dates_interval[1]) {
        date2 = new Date(_TOOLS.strToDate(dates_interval[1]));
      }
      resultsInterval.push(dateCheck>=date1 && dateCheck<=date2);
    });
    return !!resultsInterval.filter(el=>!!el).length;
  },
  dateToStr: function(date) {
    return date.toLocaleString("fr-FR").split(' ')[0].replace(',','');
  },
  strToDate: function (dateString, hourString) {
    var date = dateString.split("/");
    var repDate= new Date(date[2] + "-" + date[1] + "-" + date[0]);
    if(!!hourString){
      var min ="00";
      var hour = hourString
      if(hourString.includes(':')){
        [hour,min] = hourString.split(":");
      }
      repDate = new Date(date[2] + "-" + date[1] + "-" + date[0]+"T"+hour+":"+min+":00");
    }
     return repDate;
  },
  getNextDay: function (dateString, hourString) {
    var initialDay = _TOOLS.strToDate(dateString, hourString);
    var nextDay = new Date();
    nextDay.setDate(initialDay.getDate()+1);
    return nextDay;
  },
  strFRToStrUS:function (strFR){
    return strFR.split("/").reverse().join("-")
  },
  bindGenericEvents: function () {
    $(document).on('click.toggleVisibility', '.js-toggle-visibility', function (){
      $($(this).attr('data-target')).toggleClass('hidden');
    });
  },
  replaceAll:function(text,search,replace){
    //   html=html.replace(new RegExp("%cid%", 'g'),collectionId);
    return text.replace(new RegExp(search, 'g'),replace);
  },
  getTypePlural: function(type) {
    const specific = ['A partager', 'Vin rouge', 'Vin rosé', 'Vin blanc', 'Autre article', 'Eau', 'Eau minérale', 'Softs'],
        specific_trads = ['A partager', 'Vins rouges', 'Vins rosés', 'Vins blancs', 'Autres articles', 'Eaux', 'Eaux minérales', 'Softs'];
    return specific.indexOf(type) !== -1 ? specific_trads[specific.indexOf(type)] : type + 's';
  },
  isToday: function (someDate) {
    const today = new Date();
    return (someDate.getDate() === today.getDate() && someDate.getMonth() === today.getMonth() && someDate.getFullYear() === today.getFullYear());
  },
  isTomorrow: function(someDate) {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate()+1);
    return (someDate.getDate() === tomorrow.getDate() && someDate.getMonth() === tomorrow.getMonth() && someDate.getFullYear() === tomorrow.getFullYear());
  },
  stripHtml: function (html) {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  },

  getJsonTT:function(url){
    return  $.get(url)
        .then(function (response) {
          response = response.split('<!-- BEGIN template -->')[1] || response.split('<!-- BEGIN template -->')[0];
          response = response.split('<!-- END template -->')[0];
          return response
        })
  },
  getDateString(datefr,opts){
    var options = {is_day:true, is_date:true, is_month:true, is_year:true}
    if(!!opts){
      options=Object.assign(options,opts)
    }
    var day_index= ["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"];
    var months= ["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"];
    var date = datefr.split("/");
    var day = new Date(date[2] + "-" + date[1] + "-" + date[0]);
    var days_key = day.getDay();
    var responseDate=""
    if(options.is_day ===true)
      responseDate += day_index[days_key] + " "
    if( options.is_date ===true)
      responseDate += day.getDate() + " "
    if( options.is_month ===true)
      responseDate += months[day.getMonth()] + " "
    if(options.is_year ===true)
      responseDate += day.getFullYear();
    return responseDate;
  },

  updateStyleModalForBarUrlMobile:function(){
    if(!$("html").hasClass("supports-mobile") ){
      return false
    }
    var diffHeight=window.innerHeight - document.documentElement.clientHeight
    console.log({diffHeight,wh:window.innerHeight,cw:document.documentElement.clientHeight,cond:window.innerHeight === document.documentElement.clientHeight})
    if(diffHeight === 0) {
      //  $(".modal--quick-shop").css("margin-top", "56px")
      $(".ProductModal.product-section").addClass("withBarUrl")
      $(".ProductModal__Container .modal__form").addClass("withBarUrl")
      $(".modal__footer").addClass("withBarUrl")
    }else{
      //  $(".modal--quick-shop").css("margin-top","0")
      $(".ProductModal.product-section").removeClass("withBarUrl")
      $(".ProductModal__Container .modal__form").removeClass("withBarUrl")
      $(".modal__footer").removeClass("withBarUrl")
    }
  },
  cancelFullScreen:function() {
    var doc = window.document;
    var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;
    cancelFullScreen.call(doc);
  },
  toggleFullScreen:function() {
    var doc = window.document; var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

    var docEl = doc.documentElement;

    var requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
    var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

    if(!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
      requestFullScreen.call(docEl);
    }
    else {
          var doc = window.document; var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

      cancelFullScreen.call(doc);
    }
  }
}
  _TOOLS.bindGenericEvents();